import React from 'react'
import { withTranslation } from 'react-i18next'
import { hasError } from '../utilities'
import { InView } from 'react-intersection-observer'

class Result extends React.Component {
    render() {
        const {
            tmpStructure,
            validationStructure,
            tabsValidationResult: { errors },
            methods,
            rIndex,
            result,
            t,
        } = this.props

        const canResultVisible = i => {
            const distribution = tmpStructure._settings.distribution[i]
            return !!(distribution && distribution.isVisible)
        }

        const getResultDistributionText = i => {
            const distribution = tmpStructure._settings.distribution[i]
            if (distribution) {
                if (distribution.isVisible)
                    return `${
                        distribution.from !== distribution.to
                            ? t('({{from}}-{{to}} correct answers)', { from: distribution.from, to: distribution.to })
                            : t('({{from}} correct answers)', { from: distribution.from })
                    }`
                return t('This result will never be displayed')
            }
            return false
        }

        const handleOnScrollHighlightVisibleItem = async (inView, entry) => {
            if (inView) await methods.setFocusToResult(entry.target)
        }

        return (
            <InView
                as="li"
                key={result.id}
                className={canResultVisible(rIndex) ? '' : 'not-visible'}
                onChange={handleOnScrollHighlightVisibleItem}
                id={result.id}
                threshold={[0.5]}
            >
                <h3 className="scroll-target tab-title" data-scroll={rIndex}>
                    <span>
                        Result {rIndex + 1}
                        <span className="note">{getResultDistributionText(rIndex)}</span>
                    </span>

                    <div className="control">
                        <ul className="actions">
                            {methods.canDo('changePosition', 'results', {
                                newIndex: rIndex - 1,
                            }) ? (
                                <li
                                    className="rounded"
                                    data-icon="up"
                                    title={t('Move up')}
                                    onClick={() =>
                                        methods.onChangePosition('results', {
                                            index: rIndex,
                                            newIndex: rIndex - 1,
                                        })
                                    }
                                />
                            ) : null}
                            {methods.canDo('changePosition', 'results', {
                                newIndex: rIndex + 1,
                            }) ? (
                                <li
                                    className="rounded"
                                    data-icon="down"
                                    title={t('Move down')}
                                    onClick={() =>
                                        methods.onChangePosition('results', {
                                            index: rIndex,
                                            newIndex: rIndex + 1,
                                        })
                                    }
                                />
                            ) : null}
                            {methods.canDo('add', 'results') ? (
                                <li
                                    className="rounded"
                                    data-icon="clone"
                                    title={t('Clone')}
                                    onClick={() =>
                                        methods.onClone('results', {
                                            index: rIndex,
                                            newIndex: rIndex + 1,
                                        })
                                    }
                                />
                            ) : null}
                            {methods.canDo('remove', 'results') ? (
                                <li
                                    className="rounded"
                                    data-icon="remove"
                                    title={t('Remove')}
                                    onClick={() => methods.onRemove('results', { rIndex })}
                                />
                            ) : null}
                        </ul>
                    </div>
                </h3>
                <ul className="content">
                    <li className="block">
                        <div className="input-block">
                            <div className="label">
                                <span
                                    className="text"
                                    data-required={validationStructure._fields['results.header'].required}
                                >
                                    {t('Header')}
                                </span>
                            </div>
                            <div
                                className={`textarea-box${
                                    hasError(errors, `results[${rIndex}].header`) ? ' is-error' : ''
                                }`}
                            >
                                <textarea
                                    className="textarea-autosize"
                                    rows={1}
                                    maxLength={validationStructure._fields['results.header'].maxLength}
                                    autoComplete="off"
                                    value={result.header}
                                    onChange={evt =>
                                        methods.handleChange__tmpStructure(
                                            `results[${rIndex}].header`,
                                            evt.target.value,
                                        )
                                    }
                                />
                                {hasError(errors, `results[${rIndex}].header`) ? (
                                    <div className="error-message">{t('This field is required')}</div>
                                ) : null}
                            </div>
                        </div>
                    </li>
                    <li className="block">
                        <div className="input-block">
                            <div className="label">
                                <span
                                    className="text"
                                    data-required={validationStructure._fields['results.description'].required}
                                >
                                    {t('Description')}
                                </span>
                            </div>
                            <div
                                className={`textarea-box${
                                    hasError(errors, `results[${rIndex}].description`) ? ' is-error' : ''
                                }`}
                            >
                                <textarea
                                    className="textarea-autosize"
                                    rows={3}
                                    maxLength={validationStructure._fields['results.description'].maxLength}
                                    autoComplete="off"
                                    value={result.description}
                                    onChange={evt =>
                                        methods.handleChange__tmpStructure(
                                            `results[${rIndex}].description`,
                                            evt.target.value,
                                        )
                                    }
                                />
                                {hasError(errors, `results[${rIndex}].description`) ? (
                                    <div className="error-message">{t('This field is required')}</div>
                                ) : null}
                            </div>
                        </div>
                    </li>
                    <li className="block">
                        <div className="image-block">
                            <div className="label">
                                <span
                                    className="text"
                                    data-required={validationStructure._fields['results.image'].required}
                                >
                                    {t('Result image')}
                                </span>
                            </div>
                            <div className="inner">
                                {result.image ? (
                                    <>
                                        <div className="img" style={{ backgroundImage: `url(${result.image})` }} />
                                        <button
                                            className="select"
                                            title={t('Change image')}
                                            onClick={() =>
                                                methods.openAssetManager(data =>
                                                    methods.onPlaceImage(`results[${rIndex}].image`, data),
                                                )
                                            }
                                        >
                                            Change
                                        </button>
                                        <button
                                            className="remove"
                                            title={t('Remove image')}
                                            onClick={() =>
                                                methods.handleChange__tmpStructure(`results[${rIndex}].image`, null)
                                            }
                                        />
                                    </>
                                ) : (
                                    <button
                                        className="select select--wide"
                                        title={t('Select image')}
                                        onClick={() =>
                                            methods.openAssetManager(data =>
                                                methods.onPlaceImage(`results[${rIndex}].image`, data),
                                            )
                                        }
                                    >
                                        {t('Select')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </li>
                    {result.image ? (
                        <li className="block">
                            <div className="input-block">
                                <div className="label">
                                    <span
                                        className="text"
                                        data-required={validationStructure._fields['results.imageDisclaimer'].required}
                                        data-optional={' (optional)'}
                                    >
                                        {t('Image disclaimer')}
                                    </span>
                                </div>
                                <div className="input-box">
                                    <input
                                        autoComplete="off"
                                        type="text"
                                        maxLength={validationStructure._fields['results.imageDisclaimer'].maxLength}
                                        value={result.imageDisclaimer}
                                        onChange={evt =>
                                            methods.handleChange__tmpStructure(
                                                `results[${rIndex}].imageDisclaimer`,
                                                evt.target.value,
                                            )
                                        }
                                    />
                                    <div className="note" />
                                </div>
                            </div>
                        </li>
                    ) : null}
                </ul>
            </InView>
        )
    }
}

export default withTranslation('translations')(Result)
